import * as React from "react";
import useTranslation from ".././hooks/useTranslation";

interface LanguageSelectorProps {
  pathName: string;
}

interface Language {
  language: string;
  name: string;
  id: string;
}

interface LanguageInterface {
  [key: string]: Language;
}

const LanguageSelector = (props: LanguageSelectorProps) => {
  const { setLanguage, language } = useTranslation(props.pathName);
  let currentLanguage = language;

  function clicked(selectedLanguage: string) {
    console.log(selectedLanguage);
    setLanguage(selectedLanguage);
  }

  const allLanguages: { [key: string]: Language } = {
    swe: {
      language: "swe",
      name: "Swe",
      id: "swe",
    },
    en: {
      language: "en",
      name: "En",
      id: "en",
    },
  };

  function withoutCurrentLang() {
    let selectableLanguages: { [key: string]: Language } = {};
    Object.assign(selectableLanguages, allLanguages);
    delete selectableLanguages[currentLanguage];
    return selectableLanguages;
  }

  let selectableLanguages: LanguageInterface = withoutCurrentLang();

  return (
    <>
      <div className=" flex sm:mt-0 mt-2 sm:h-14 sm:w-32  relative cursor-pointer">
        <div className="flex gap-x-2  sm:m-auto">
          <div
            style={{
              fontWeight: currentLanguage === "swe" ? 500 : 100,
            }}
            onClick={() => clicked("swe")}
          >
            SWE
          </div>
          <div> / </div>

          <div
            onClick={() => clicked("en")}
            style={{
              fontWeight: currentLanguage === "en" ? 500 : 100,
            }}
          >
            EN
          </div>
        </div>
      </div>
    </>

    // <div className="dropdown">
    //   <p key={allLanguages[currentLanguage].id}>
    //     {allLanguages[currentLanguage].name}
    //   </p>
    //   <div className="dropdown-content">
    //     {Object.keys(selectableLanguages).map((selectableLanguage) => (
    //       <p
    //         className="mt-12"
    //         key={selectableLanguages[selectableLanguage].id}
    //         onClick={() => clicked(selectableLanguage)}
    //       >
    //         {selectableLanguages[selectableLanguage].name}
    //       </p>
    //     ))}
    //   </div>
    // </div>
  );
};

export default LanguageSelector;
